/**
 * Where a /ogreclan signin link lands (draft.ogreclan.com/signin#token): signs in with the token, which never leaves
 * the address bar except to the API, then goes to the leagues. For players a Global Admin let sign in with Showdown.
 */
import { useEffect, useState } from 'preact/hooks';
import { api } from '../api';
import { refreshMe } from '../me';
import { navigate } from '../router';
import { Loading } from '../ui';

export function SignInPage() {
	const [error, setError] = useState<string | null>(null);
	useEffect(() => {
		const token = location.hash.slice(1);
		// out of the address bar and history, so it isn't shared or bookmarked by mistake
		history.replaceState(null, '', '/signin');
		if (!token) {
			setError(`This page signs you in from a link that /ogreclan signin gives you on play.ogreclan.com.`);
			return;
		}
		api.post('/api/auth/showdown', { token }).then(async () => {
			await refreshMe();
			navigate('/league', true);
		}, (e: Error) => setError(e.message));
	}, []);

	if (!error) return <Loading text="Signing you in…" />;
	return <div class="card">
		<h1>Sign in with Showdown</h1>
		<p class="notice bad">{error}</p>
		<p>Log in on <a href="https://play.ogreclan.com">play.ogreclan.com</a> as your Showdown name, type <code>/ogreclan signin</code> in
			any chat box, and open the link it gives you. Each link works once, for 5 minutes.</p>
	</div>;
}
